// import { helpers } from './theme/helpers.js';
// import { templates } from './theme/templates.js'
import { ajaxChat } from './theme/components/ajaxChat.js';
import { notifications } from './theme/components/notifications.js';
import { accomodations } from './theme/components/accomodations.js';
import { datePicker } from './theme/components/datePicker.js';
import { addressAutocomplete } from './theme/components/addressAutocomplete.js';
import { inputGroup } from './theme/components/inputGroup.js';
import { lightBox } from './theme/components/lightBox.js';
import { accomodationReservation } from './theme/components/accomodationReservation.js';
import { reservation } from './theme/components/reservation.js';
import { sliders } from './theme/components/sliders.js';
import { userMenu } from './theme/components/userMenu.js';
import { counterBox } from './theme/components/counterBox.js';
import { repeater } from './theme/components/repeater.js';
import { activeLinkWatcher } from './theme/components/activeLinkWatcher.js';
import { creditsQuantitySelect } from './theme/components/creditsQuantitySelect.js';
import { modal } from './theme/components/modal.js';
import { reviewAccomodation } from './theme/components/reviewAccomodation.js';
import { reviewAccomodationStars } from './theme/components/reviewAccomodationStars.js';
import { accomodationTop } from './theme/components/accomodationTop.js';
import { accomodationView } from './theme/components/accomodationView.js';
import { currencySwitcherWooCommerce } from './theme/components/currencySwitcherWooCommerce.js';
import { currencySwitcherAccomodation } from './theme/components/currencySwitcherAccomodation.js';
import { counterSlider } from './theme/components/counterSlider.js';
import { newsletter } from './theme/components/newsletter.js';
import { forms } from './theme/components/forms.js';
import { reservations } from './theme/components/reservations.js';
import { carMileage } from './theme/components/carMileage.js';
import { accomodationPeriodType } from './theme/components/accomodationPeriodType.js';


window.theme = {
	globals: {
		isDevelopment: true,
		// isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
	},

	init: function () {
		var self = this;

		//global jquery ajax settings
		jQuery.ajaxSetup({
			beforeSend: function (xhr, settings) {
				// Add the nonce to the request data automatically
				if (settings.method === "POST" || settings.type === "POST") {
					settings.data = settings.data || '';
					settings.data += '&btkc_nonce=' + sikmoVars.ajax_nonce;
				} else {
					settings.url = settings.url || '';
					settings.url += '&btkc_nonce=' + sikmoVars.ajax_nonce;
				}
			}
		});

		// external
		ajaxChat.init({
			selector: "#js-ajax-chat",
			ajax_url: sikmoVars.ajax_url,
		});
		notifications.init();
		accomodations.init();
		datePicker.init();
		inputGroup.init();
		lightBox.init();
		accomodationReservation.init();
		reservation.init();
		sliders.init();
		userMenu.init();
		counterBox.init();
		repeater.init();
		activeLinkWatcher.init();
		creditsQuantitySelect.init();
		modal.init();
		reviewAccomodation.init();
		reviewAccomodationStars.init();
		accomodationTop.init();
		accomodationView.init();
		currencySwitcherWooCommerce.init();
		currencySwitcherAccomodation.init();
		counterSlider.init();
		newsletter.init();
		forms.init();
		reservations.init();
		carMileage.init();
		accomodationPeriodType.init();

		self.preventSendingFormsViaEnterKey();
		self.AcfGalleryUpdate();
		self.togglePass();
	},

	preventSendingFormsViaEnterKey: function () {
		jQuery('form#new-accomodation').on('keypress', function(event) {
			// Check if the Enter key (key code 13) was pressed
			if (event.which !== 13) {
				return;
			}

			// Allow Enter key if the event target is a textarea or has the class 'allow-enter'
			const target = event.target;
			if (target.tagName.toLowerCase() !== 'textarea') {
				event.preventDefault();
			}
		});
	},
	
	AcfGalleryUpdate: function () {
		jQuery( '.acf-gallery-update' ).on( 'click', function(event) {
			setTimeout(function(){
				jQuery( '.acf-gallery-close' ).click();
			}, 500 );
		});
	},
	
	togglePass: function () {
		jQuery( '.toggle-pass' ).on( 'click', function(event) {
			const passInput = jQuery( this ).parent().find( 'input[type="password"]' );
			const passInputToggled = jQuery( this ).parent().find( 'input.toggled-pass' );
			
			if( passInputToggled ) {
				passInputToggled.attr( 'type', 'password' );
				passInputToggled.removeClass( 'toggled-pass' );
			}

			if( passInput ) {
				passInput.attr( 'type', 'text' );
				passInput.addClass( 'toggled-pass' );
			}
		});
	},
};

jQuery(document).ready(function ($) {
	theme.init();
});

//make instance for google maps api imeditialy
window.addressAutocomplete = addressAutocomplete; //make it global accessible for Google Maps API JS